"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _classnames = _interopRequireDefault(require("classnames"));

/** Map authCodeColor values from the backend to CSS modifier classes for the auth status pill */
var AUTH_COLOR_CLASS_MAP = {
  GREEN: 'auth-status-pill--green',
  RED: 'auth-status-pill--red',
  YELLOW: 'auth-status-pill--yellow'
};
/** Map authCodeColor values to CSS modifier classes for the status message text color */

var AUTH_STATUS_MESSAGE_COLOR_MAP = {
  GREEN: 'app-status-message--green',
  RED: 'app-status-message--red',
  YELLOW: 'app-status-message--yellow'
};

var AppCard = function AppCard(_ref) {
  var _AUTH_COLOR_CLASS_MAP, _AUTH_STATUS_MESSAGE_;

  var title = _ref.title,
      isInstalled = _ref.isInstalled,
      description = _ref.description,
      appLink = _ref.appLink,
      isVisible = _ref.isVisible,
      imageName = _ref.imageName,
      _ref$isBeta = _ref.isBeta,
      isBeta = _ref$isBeta === void 0 ? false : _ref$isBeta,
      authStatus = _ref.authStatus,
      authStatusDescription = _ref.authStatusDescription,
      authCodeColor = _ref.authCodeColor;
  if (!isVisible) return null;
  var authColorClass = authCodeColor ? (_AUTH_COLOR_CLASS_MAP = AUTH_COLOR_CLASS_MAP[authCodeColor]) !== null && _AUTH_COLOR_CLASS_MAP !== void 0 ? _AUTH_COLOR_CLASS_MAP : '' : '';
  var statusMessageColorClass = authCodeColor ? (_AUTH_STATUS_MESSAGE_ = AUTH_STATUS_MESSAGE_COLOR_MAP[authCodeColor]) !== null && _AUTH_STATUS_MESSAGE_ !== void 0 ? _AUTH_STATUS_MESSAGE_ : '' : '';
  return (0, _preact.h)("a", {
    className: "integration-app-card-container",
    href: (0, _absoluteUrlRuntime.resolveUrl)(appLink)
  }, (0, _preact.h)("div", {
    className: "app-card-header-container"
  }, imageName && (0, _preact.h)("div", {
    className: "app-card-image-wrapper"
  }, (0, _preact.h)("img", {
    height: 40,
    width: 40,
    src: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.default)('basePath'), "images/integrations/").concat(imageName, ".png"))
  })), (0, _preact.h)("div", {
    className: "app-card-details-wrapper"
  }, (0, _preact.h)("div", {
    className: "app-card-title-wrapper"
  }, isInstalled && (0, _preact.h)(_assets.default, {
    customClass: "app-installed-logo",
    icon: "solvedQuestion",
    width: 16,
    height: 16
  }), (0, _preact.h)("div", {
    className: "app-card-title"
  }, title), (0, _preact.h)("div", {
    className: "app-card-title-extras"
  }, authStatus && (0, _preact.h)("div", null, (0, _preact.h)("span", {
    className: "auth-status-pill ".concat(authColorClass),
    title: authStatusDescription
  }, authStatus)), isBeta && (0, _preact.h)("div", null, (0, _preact.h)("span", {
    className: "app-card-title-extra__card beta-label-secondary"
  }, "BETA")))), (0, _preact.h)("div", {
    className: "app-description-container"
  }, description), authStatusDescription && (0, _preact.h)("div", {
    className: (0, _classnames.default)('app-status-message', statusMessageColorClass)
  }, authStatusDescription))));
};

var _default = AppCard;
exports.default = _default;